import React from "react";
import { Typography } from "@mui/material";

// const headerBlockStyle = {
//     backgroundColor: "#000",
//     padding: "12px 16px 16px",
//     borderBottom: "none",
// };

const titleStyle = {
    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: 600,
    color: "#242424"
};

const titleUnderlineStyle = {
    width: "100%",
    height: "2px",
    backgroundColor: "#242424",
    marginBottom: "20px",
};

const disclaimerStyle = {
    fontFamily: "Poppins",
    fontSize: "12px",
    color: "#242424",
    marginBottom: "38px",
    lineHeight: 1.4,
    display: "block",
    width: "100%",
};

const thresholdStyle = {
    fontFamily: "Poppins",
    fontSize: "15px",
    fontWeight: 700,
    color: "#242424",
    marginBottom: "12px",
};

const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    fontFamily: "Poppins",
    fontSize: "14px",
    backgroundColor: "#FFF",
};

const theadStyle = {
    backgroundColor: "#EEEEEE",
    color: "#242424",
    fontWeight: 700,
    borderBottom: "2px solid #000",
};

const thStyle = {
    padding: "9px 14px",
    textAlign: "left",
    fontWeight: 700,
};

const tbodyStyle = {};

const tdStyle = {
    padding: "9px 14px",
    border: "none",
    borderBottom: "1px solid #E0E0E0",
    backgroundColor: "#FFF",
    color: "#000",
    textAlign: "left",
};

const containerStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    alignSelf: "stretch",
    width: "100%",
};

const episodeCardStyle = {
    borderRadius: "4px",
    overflow: "hidden",
    marginBottom: "52px",
};

const DISCLAIMER_TEXT =
    "The environmental data is for informational use only. Environmental source data accuracy has not been validated.";

/**
 * Renders a list of drop episodes, each with a header (title, disclaimer, alert threshold) and a table of rows.
 * @param {Array<{ alertThreshold?: number, rows?: Array<{ time?, spo2?, hr?, alt?, hum?, aqi?, baroIndex?, patientNotes? }> }>} episodes
 */
export default function DropEpisodesSection({ episodes = [] }) {
    if (!episodes.length) return null;

    return (
        <div style={containerStyle}>
            {episodes.map((episode, index) => (
                <div key={index} style={episodeCardStyle}>
                    <div>
                        <Typography style={titleStyle}>
                            Drop Episode {index + 1}
                        </Typography>
                        <div style={titleUnderlineStyle} />
                        <div style={disclaimerStyle}>{DISCLAIMER_TEXT}</div>
                        <Typography style={thresholdStyle}>
                            Alert Threshold:{" "}
                            {episode.alert_threshold != null
                                ? `${episode.alert_threshold}%`
                                : "—"}
                        </Typography>
                    </div>
                    <table style={tableStyle}>
                        <thead>
                            <tr style={theadStyle}>
                                <th style={thStyle}>Time</th>
                                <th style={thStyle}>SpO₂</th>
                                <th style={thStyle}>PR</th>
                                <th style={thStyle}>Alt</th>
                                <th style={thStyle}>Hum</th>
                                <th style={thStyle}>AQI</th>
                                <th style={thStyle}>Baro:Index</th>
                                <th style={thStyle}>Patient Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(episode.rows || []).map((row, rowIndex) => (
                                <tr key={rowIndex} style={tbodyStyle}>
                                    <td style={tdStyle}>{row.time ?? "—"}</td>
                                    <td style={tdStyle}>{row.spo2 ?? "—"}</td>
                                    <td style={tdStyle}>{row.hr ?? "—"}</td>
                                    <td style={tdStyle}>{row.alt ?? "—"}</td>
                                    <td style={tdStyle}>{row.hum ?? "—"}</td>
                                    <td style={tdStyle}>{row.aqi ?? "—"}</td>
                                    <td style={tdStyle}>
                                        {row.baroIndex ?? row.baro ?? "—"}
                                    </td>
                                    <td style={tdStyle}>
                                        {row.patientNotes ?? row.patient_notes ?? "—"}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
}
